import { ReactNode } from 'react'
import { useAuth } from '../../contexts/AuthProvider'
import { RolApp } from '../../types/auth'
import { Alerta } from '../kit'

/**
 * Solo para cuentas con alguno de los roles. Como RequireStaff: la API igual responde 403;
 * esto evita mostrar una pantalla que no va a funcionar.
 */
export default function RequireRol({ roles, children }: { roles: RolApp[]; children: ReactNode }) {
  const { puede } = useAuth()
  if (!puede(...roles))
    return <Alerta tipo="error" titulo="Sin acceso">Tu cuenta no tiene el rol para esta sección. Pídelo a quien administra la aplicación.</Alerta>
  return <>{children}</>
}
